import React from 'react'
import {Layout, Menu, Breadcrumb, Row, Col, ConfigProvider} from 'antd'
import {Router, Link} from "@reach/router";
import Addresses from "../components/addresses/Addresses";
import Department from "../components/department/Department";
import Employee from "../components/employee/Employee";
import Role from "../components/role/Role";
import Brand from '../components/brand/Brand'
import Category from "../components/category/Category";
import Warehouse from "../components/warehouse/Warehouse";
import Supplier from "../components/supplier/Supplier";
import Tax from "../components/tax/Tax";
import Stock from "../components/stok/Stock";
import Customer from "../components/customer/Customer";
import ShippingOrderContainer from "../components/shippingOrder/ShippingOrderContainer";
import ProductionLine from "../components/productionLine/ProductionLine";
import Production from "../components/production/Production";
import ProductionProcess from "../components/productionProcess/ProductionProcess";
import ProductionCalendar from "../components/productionCalendar/ProductionCalendar";
import WarehouseIncoming from "../components/warehouseIncoming/WarehouseIncoming";
import WarehouseOutgoingTabs from "../components/warehouseOutgoing/WarehouseOutgoingTabs";
import Appointment from "../components/appointment/Appointment";
import ProductionCost from "../components/productionCost/ProductionCost";
import RecipeLayoutContainer from "../components/recipe/RecipeLayoutContainer";
import RelevantPerson from "../components/relevantPerson/RelevantPerson";
import Scrap from "../components/scrap/Scrap";
import OfferContainer from "../components/offer/Offer";
import PurchaseContainer from "../components/purchase/PurchaseContainer";
import AppointmentReports from "../components/reports/AppointmentReports";
import ProductionLineReports from "../components/reports/ProductionLineReports";
import WarehouseReports from "../components/reports/WarehouseReports";
import WarehouseStockReports from "../components/reports/WarehouseStockReports";
import BrandClusteredOfferReports from "../components/reports/BrandClusteredOfferReports";
import TotalProfitBySellingReports from "../components/reports/TotalProfitBySellingReports";
import PurchaseCostReports from "../components/reports/PurchaseCostReports";
import CustomerReport from '../components/reports/CustomerReport';
import gokhanLogo from '../logo/gokhanLogo.jpeg'
import armaledLogo from '../logo/armaled_logo.jpeg'
import {
    PlusCircleOutlined,
    HomeOutlined,
    LockOutlined,
    RightOutlined,
    DashboardOutlined,
    BarChartOutlined
} from "@ant-design/icons";
import UserMenu from "../components/topNavigation/UserMenu";
import UploaderAndPath from "../components/topNavigation/UploaderAndPath";
import config from "../config";
import LandingContent from "../components/landing/LandingContent";
import DiffBetweenOfferAndShippingOrder from "../components/reports/DiffBetweenOfferAndShippingOrder";

const {Header, Footer, Sider, Content} = Layout
const {SubMenu} = Menu
const logoStyle = {
    height: '64px',
}
const imgStyle = {
    width: '100%',
    height: '100px',
    padding: '28px 18px 28px 18px'
}

const Landing = () => {

    const logo = config.currentTenant() === 'arma' ? armaledLogo : gokhanLogo

    return (
        <React.Fragment>
            <ConfigProvider>
                <Layout className={'layout-root'}>
                    <Sider breakpoint={"md"} collapsedWidth={"0"} collapsible className={'sider'}>
                        <div className={logoStyle}><Link to={'/landing'}><img style={imgStyle} src={logo} alt={'Şirket Logosu'}/></Link></div>
                        <Menu theme={'dark'} mode={'inline'}>
                            <Menu.Item key={'15'} style={{backgroundColor: '#0a813e'}}><Link to={'offer/list'}>Teklif</Link></Menu.Item>
                            <Menu.Item key={'21'} style={{backgroundColor: '#15adc8'}}><Link to={'appointment'}>Randevu</Link></Menu.Item>
                            <Menu.Item key={'16'} style={{backgroundColor: '#8f0c35'}}> <Link to={'purchase'}>Satın Alma</Link></Menu.Item>
                            <Menu.Item key={'13'} style={{backgroundColor: '#B73D0E'}}><Link to={'shipping-order/list'}>Sevkiyat Emri</Link></Menu.Item>
                            <SubMenu key={'sub1'} title={'Tanımlamalar'} icon={< PlusCircleOutlined/>}>
                                <Menu.Item key={'1'} icon={< RightOutlined/>}><Link
                                    to={'customer'}>Müşteriler</Link></Menu.Item>
                                <Menu.Item key={'2'} icon={< RightOutlined/>}><Link
                                    to={'department'}>Departmanlar</Link></Menu.Item>
                                <Menu.Item key={'3'} icon={< RightOutlined/>}><Link
                                    to={'tax'}>Vergiler</Link></Menu.Item>
                                <Menu.Item key={'4'} icon={< RightOutlined/>}><Link
                                    to={'brand'}>Marka</Link></Menu.Item>
                                <Menu.Item key={'5'} icon={< RightOutlined/>}><Link
                                    to={'category'}>Kategoriler</Link></Menu.Item>
                                <Menu.Item key={'6'} icon={< RightOutlined/>}><Link to={'production-line'}>Üretim
                                    Hattı</Link></Menu.Item>
                                <Menu.Item key={'7'} icon={< RightOutlined/>}><Link to={'production-cost'}>Üretim
                                    Giderleri</Link></Menu.Item>
                                <Menu.Item key={'9'} icon={< RightOutlined/>}><Link
                                    to={'supplier'}>Tedarikçi</Link></Menu.Item>
                            </SubMenu>
                            <SubMenu key={'sub2'} title={'Depo'} icon={< HomeOutlined/>}>
                                <Menu.Item key={'8'} icon={< RightOutlined/>}><Link
                                    to={'warehouse'}>Depo</Link></Menu.Item>
                                <Menu.Item key={'10'} icon={< RightOutlined/>}><Link
                                    to={'stock'}>Stok</Link></Menu.Item>
                                <Menu.Item key={'11'} icon={< RightOutlined/>}><Link to={'warehouse-incoming'}>Depo
                                    Giriş</Link></Menu.Item>
                                <Menu.Item key={'12'} icon={< RightOutlined/>}><Link to={'warehouse-outgoing'}>Depo
                                    Çıkış</Link> </Menu.Item>
                            </SubMenu>
                            <SubMenu key={'sub3'} title={"Üretim"} icon={<DashboardOutlined/>}>
                                <Menu.Item key={'14'} icon={< RightOutlined/>}><Link to={'recipe'}>Reçete</Link></Menu.Item>
                                <Menu.Item key={'17'} icon={<RightOutlined/>}> <Link to={'production'}>Üretim
                                    Emri</Link></Menu.Item>
                                <Menu.Item key={'18'} icon={<RightOutlined/>}> <Link to={'production-process'}>Üretim
                                    Giriş</Link></Menu.Item>
                                <Menu.Item key={'19'} icon={<RightOutlined/>}> <Link to={'production-calendar'}> Üretim
                                    Takvimi </Link> </Menu.Item>
                                <Menu.Item key={'20'} icon={<RightOutlined/>}> <Link to={'scrap'}> Hurda Giriş </Link>
                                </Menu.Item>

                            </SubMenu>
                            <SubMenu key={'sub4'} title={'Yönetim'} icon={< LockOutlined/>}>
                                <Menu.Item key={'22'} icon={< RightOutlined/>}><Link to={'employee'}> Çalışanlar </Link></Menu.Item>
                                <Menu.Item key={'23'} icon={< RightOutlined/>}><Link
                                    to={'role'}>Roller</Link></Menu.Item>
                            </SubMenu>
                            <SubMenu key={'sub5'} title={'Raporlamalar'} icon={<BarChartOutlined />}>
                                <Menu.Item key={'24'} icon={< RightOutlined/>}><Link to={'appointment-reports'}>Randevu</Link></Menu.Item>
                                <Menu.Item key={'25'} icon={< RightOutlined/>}><Link to={'production-line-reports'}>Üretim Hattı</Link></Menu.Item>
                                <Menu.Item key={'26'} icon={< RightOutlined/>}><Link to={'warehouse-reports'}>Depo</Link></Menu.Item>
                                <Menu.Item key={'27'} icon={< RightOutlined/>}><Link to={'warehouse-stock-reports'}>Stok</Link></Menu.Item>
                                <Menu.Item key={'28'} icon={< RightOutlined/>}><Link to={'brand-offer-reports'}>Marka Bazlı Teklif</Link></Menu.Item>
                                <Menu.Item key={'29'} icon={< RightOutlined/>}><Link to={'profit-selling-reports'}>Satış Bazlı Ciro</Link></Menu.Item>
                                <Menu.Item key={'30'} icon={< RightOutlined/>}><Link to={'purchase-cost-reports'}>Satın Alma Maliyet</Link></Menu.Item>
                                <Menu.Item key={'31'} icon={< RightOutlined/>}><Link to={'offer-shipping-diff'}>Teklif Raporları</Link></Menu.Item>
                                <Menu.Item key={'32'} icon={< RightOutlined/>}><Link to={'customer-reports'}>Müşteri Raporları</Link></Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Sider>
                    <Layout>
                        <Header style={{background: "white"}}>
                            <Row justify={'space-between'} wrap={{wrap: false}}>
                                <Col span={15}>
                                    <UploaderAndPath />
                                </Col>
                                <Col span={3}>
                                    <UserMenu/>
                                </Col>
                            </Row>

                        </Header>
                        <Breadcrumb>
                            {/*    BREAD CRUMBS HERE */}
                        </Breadcrumb>
                        <Content className={'contentLayout'}>
                            <Router>
                                <Appointment path={'/appointment'}/>
                                <AppointmentReports path={'/appointment-reports'}/>
                                <Addresses path={'/addresses/:customerId'}/>
                                <Brand path={'/brand'}/>
                                <BrandClusteredOfferReports path={'/brand-offer-reports'} />
                                <Category path={'/category'}/>
                                <Customer path={'/customer'}/>
                                <Department path={'/department'}/>
                                <DiffBetweenOfferAndShippingOrder path={'/offer-shipping-diff'}/>
                                <Employee path={'/employee'}/>
                                <LandingContent path={'/'}/>
                                <OfferContainer path={'/offer/*'}/>
                                <RecipeLayoutContainer path={'/recipe/*'}/>
                                <RelevantPerson path={'/relevant-person/:customerId'}/>
                                <Role path={'/role'}/>
                                <Production path={'/production'}/>
                                <ProductionCalendar path={'/production-calendar'}/>
                                <ProductionProcess path={'/production-process'}/>
                                <ProductionLine path={'/production-line'}/>
                                <ProductionLineReports path={'production-line-reports'} />
                                <ProductionCost path={'/production-cost'}/>
                                <PurchaseContainer path={'/purchase/*'} />
                                <PurchaseCostReports path={'/purchase-cost-reports'} />
                                <Scrap path={'/scrap'}/>
                                <ShippingOrderContainer path={'/shipping-order/*'}/>
                                <Stock path={'/stock'}/>
                                <Supplier path={'/supplier'}/>
                                <Tax path={'/tax'}/>
                                <TotalProfitBySellingReports path={'/profit-selling-reports'} />
                                <Warehouse path={'/warehouse'}/>
                                <WarehouseIncoming path={'/warehouse-incoming'}/>
                                <WarehouseOutgoingTabs path={'/warehouse-outgoing'}/>
                                <WarehouseReports path={'/warehouse-reports'} />
                                <WarehouseStockReports path={'/warehouse-stock-reports'} />
                                <CustomerReport path={'/customer-reports'} />
                            </Router>
                        </Content>
                        <Footer style={{textAlign: 'center'}}>PİNE | MRP @2020 Created By Pine</Footer>
                    </Layout>
                </Layout>
            </ConfigProvider>
        </React.Fragment>
    )
}
export default Landing